import { SearchCondition, SearchResult } from '@gateway.maintenance'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface SupplierSearchState {
  searchCondation: SearchCondition
  searchResult: SearchResult[]
}

const initialState: SupplierSearchState = {
  searchCondation: {
    supplierNm: '',
    supplierBranchNm: '',
    branches: [],
    supplierPerson: '',
    expense: [],
    buildingDiscloseFlg: [],
    ourCompanyCapacityFlg: [],
    soyukaiFlg: [],
    hearingSheetFlg: [],
    replyReqFlg: []
  },
  searchResult: []
}

const supplierSearchSlice = createSlice({
  name: 'supplierSearch',
  initialState,
  reducers: {
    setSearchCondition: (state, action: PayloadAction<SearchCondition>) => {
      state.searchCondation = action.payload
    },
    setSearchResult: (state, action: PayloadAction<SearchResult[]>) => {
      state.searchResult = action.payload
    }
  }
})

export const SupplierSearchActions = supplierSearchSlice.actions
export const SupplierSearchReducers = supplierSearchSlice.reducer
